(function () {

  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').controller('AbaPrincipalVisualizacao', AbaPrincipal);

  function AbaPrincipal(GlosaService, ParametroService, $state) {

    var vm = this;
    vm.init = init;
    vm.justificativaGlosaTotal = null;

    vm.init();

    function init() {

      vm.parametro = {};

      vm.promotorSelecionado = $state.params.promotorSelecionado;
      vm.relDkSelecionado = $state.params.relDkSelecionado;
      vm.periodoSelecionado = $state.params.periodoSelecionado;

      GlosaService.getLinhasPrincipal(vm.promotorSelecionado.originalObject.pessDk,
        vm.relDkSelecionado).then(data => {
        vm.linhas = data;
        vm.existeAbertoCom30Dias = (vm.linhas[2] !== undefined && vm.linhas[2] !== null);
      });

      GlosaService.getRelatorioCorrente(vm.promotorSelecionado.originalObject.pessDk,
        vm.relDkSelecionado).then(data => {
        vm.currentRel = data;
        vm.parametro.ultimoDiaMes = vm.currentRel.lastDay;
      });

      GlosaService.getEnvioRegistro(vm.promotorSelecionado.originalObject.pessDk,
        vm.relDkSelecionado).then(data => {
        vm.registroMsmMca = data;
      });

      GlosaService.recuperaJustificativaGlosaTotalByRmenDK(
                                  vm.promotorSelecionado.originalObject.pessDk,
                                  vm.relDkSelecionado).then(data => {
        vm.justificativaGlosaTotal = data.justificativaGlosaTotal;
      });

      ParametroService.getLimiteDiasFeitosVistaAberta(vm.periodoSelecionado).then(data => {
        vm.parametro.quantidadeDias = data.quantidadeDias;
      });

    }
  }

})();
